export default __webpack_public_path__ + "static/media/tienkhoa.e03578cf.png";